import { fillString } from '@local_modules/generic/string-template.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

import htmlTemplateIndex from './index.html'
import { loadEntitiesSyncStats } from './load-entities-sync-stats.js'
import { showTableEntitiesSyncStats } from './show-table.js'

import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'

/**
 *
 * @returns
 */
export async function showPageDataSyncsPG (params) {
  console.log('showPageDataSyncsPG')

  const { containerElementId, browserAppUser, browserAppAccount, appAccountId } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  // Set page title
  document.title = ['Group Entities:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  const [entitiesSyncStatsResponse] = await Promise.all([
    loadEntitiesSyncStats(appAccountId)
  ])

  showTableEntitiesSyncStats(entitiesSyncStatsResponse, browserAppAccount)
}
